import React, { useState } from 'react'
import { I18n } from 'react-redux-i18n'
import { FormGroup, Label, Col } from 'reactstrap'
import Select from 'react-select'
import { STYLES_REACT_SELECT_NEW_WITH_INSET_SHADOW } from '../../../../../../constants'

const SetExcelColumns = ({ handleSelected, colName, colIndex, options, colKey, exampleValues }) => {
  const setColLabel = () => {
    switch(colName) {
      case 'name':
        return I18n.t('dashboard_name')
      case 'lastName':
        return I18n.t('dashboard_last-name')
      case 'phone':
        return I18n.t('dashboard_phone')
      case 'occasion_name':
        return I18n.t('dashboard_occasion-name')
      case 'occasion_id':
        return I18n.t('dashboard_occasion-id')
      case 'codcliente':
        return I18n.t('dashboard_client-code')
      default:
        return ''
    }
  }

  const [exampleValue, setExampleValue] = useState('')

  const handleOnChange = ({ label, value }, { name }) => {
    // show example
    setExampleValue(exampleValues[label])
    handleSelected({ label, value }, { name }, colIndex, options)
  }

  return (
    <>
      <Col md={3}>
        <FormGroup inline>
          <Label for='excel-columns'>{setColLabel()} </Label>
          <Select
            key={colKey}
            required
            placeholder={colIndex === 1 ? I18n.t('additional_column') : I18n.t('column')}
            options={options}
            name={colName}
            onChange={handleOnChange}
            styles={STYLES_REACT_SELECT_NEW_WITH_INSET_SHADOW}
          />
        </FormGroup>
        <span className='excel-column-example'>
          <b>{exampleValue}</b>
        </span>
      </Col>
    </>
  )
}

export default SetExcelColumns
